import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from "@mui/material";
import { createPOSCustomer } from "../api/posApi";

interface AddCustomerModalProps {
  open: boolean;
  onClose: () => void;
  onCustomerCreated: (user: { id: number; name: string; phone?: string; email?: string }) => void;
  searchTerm: string;
}

const AddCustomerModal: React.FC<AddCustomerModalProps> = ({
  open,
  onClose,
  onCustomerCreated,
  searchTerm,
}) => {
  const [newCustomer, setNewCustomer] = useState({ name: "", phone: "", email: "" });

  // Parse the search term to pre-fill the form
  useEffect(() => {
    const isPhone = /^\d+$/.test(searchTerm);
    const isEmail = /\S+@\S+\.\S+/.test(searchTerm);
    const [firstName, lastName] = searchTerm.includes(" ") ? searchTerm.split(" ") : [searchTerm, ""];

    setNewCustomer({
      name: !isPhone && !isEmail ? `${firstName} ${lastName}`.trim() : "",
      phone: isPhone ? searchTerm : "",
      email: isEmail ? searchTerm : "",
    });
  }, [searchTerm]);

  const handleCreateCustomer = async () => {
    if (!newCustomer.name || !newCustomer.phone) {
      alert("Name and phone are required!");
      return;
    }

    try {
      const createdUser = await createPOSCustomer(newCustomer);
      onCustomerCreated(createdUser);
      onClose();
    } catch (err) {
      console.error("Error adding user:", err);
      alert("Failed to add new customer.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Customer</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <TextField
            label="Customer Name"
            value={newCustomer.name}
            onChange={(e) => setNewCustomer({ ...newCustomer, name: e.target.value })}
            fullWidth
          />
          <TextField
            label="Phone Number"
            value={newCustomer.phone}
            onChange={(e) => setNewCustomer({ ...newCustomer, phone: e.target.value })}
            fullWidth
          />
          <TextField
            label="Email (Optional)"
            value={newCustomer.email}
            onChange={(e) => setNewCustomer({ ...newCustomer, email: e.target.value })}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleCreateCustomer} variant="contained">
          Add Customer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCustomerModal;